import { Eye } from "lucide-react";
import { useNavigate } from "react-router-dom";
import type { Investment } from "@/types";
import { statusBadgeIntent, statusLabel } from "@/utils/application-status";

import Badge from "@/components/Badge";
import IconButton from "@/components/buttons/IconButton";
import Table from "@/components/Table";
import DoubleWord from "@/components/DoubleWord";



export type InvestimentListItemProps = {
    investment: Investment
}

const InvestimentListItem = ({ investment }: InvestimentListItemProps) => {
    const navigate = useNavigate();
    const intl = Intl.NumberFormat();

    return (
        <Table.Row className="text-secondary font-medium">
            <Table.Cell>
                {investment.applicationId}
            </Table.Cell>
            <Table.Cell className="font-bold">
                {investment.capitalInvestment.shareholders[0]?.firstName ?? "NA"} {investment.capitalInvestment.shareholders[0]?.lastName ?? "NA"}
            </Table.Cell>
            <Table.Cell className="text-secondary/60 font-normal">
                {investment.businessDetails.projectName}
            </Table.Cell>
            <Table.Cell>
                <DoubleWord 
                    primary={intl.format(investment.capitalInvestment.estimatedInvestmentAmount)}
                    secondary={investment.capitalInvestment.currency}
                    className="text-sm"
                />
            </Table.Cell>
            <Table.Cell>
                <Badge
                    intent={statusBadgeIntent(investment.applicationStatus)}
                    text={statusLabel(investment.applicationStatus) ?? ""}
                />
            </Table.Cell>
            <Table.Cell
                className={"flex items-center justify-center gap-3 opacity-80"}
            >
                <IconButton 
                    intent="secondary" 
                    className="border border-secondary-200"
                    onClick={() => navigate(`applications-details/${investment.applicationId}`, {
                        state: {
                            investmentDetails:investment
                        }
                    })}
                >
                    <Eye 
                        className="size-4" 
                    />
                </IconButton>
            </Table.Cell>
        </Table.Row>
    )
}

export default InvestimentListItem